import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { BuyerAnalyticsTemplate as template } from './buyer-analytics.template';
import { BuyerAnalyticsStyles as styles } from './buyer-analytics.styles';

const name = 'buyer-analytics-route';

@customElement({
  name,
  template,
  styles,
})
export class BuyerAnalytics extends FASTElement {
  constructor() {
    super();
  }
}
